(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MdaCartGiftCore = api;
})(typeof self !== 'undefined' ? self : this, function () {
  const GIFT_PROP = '_mda_gift';
  const GIFT_TAG = 'hol26';

  function isBlank(s) {
    return s === undefined || s === null || String(s).trim() === '';
  }

  // config: window.MDA_GIFT ({ variantId: string|number, windows: [[start, end], ...] })
  // now: store-time stamp 'YYYY-MM-DD HH:MM'; isActive: MdaSchedule.isActive
  // A window with both sides blank is NOT configured (isActive would call it always open).
  // A window with a bad format (isActive returns null) is inactive.
  function giftRule(config, now, isActive) {
    const none = { variantId: 0, active: false };
    if (!config || typeof config !== 'object') return none;
    const raw = config.variantId;
    if (isBlank(raw) || !/^\d+$/.test(String(raw).trim())) return none;
    const variantId = Number(String(raw).trim());
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return none;
    const windows = Array.isArray(config.windows) ? config.windows : [];
    const active = windows.some(function (w) {
      if (!Array.isArray(w)) return false;
      if (isBlank(w[0]) && isBlank(w[1])) return false;
      return isActive(w[0], w[1], now) === true;
    });
    return { variantId: variantId, active: active };
  }

  // Any line of the gift variant counts, so a hand-added second gift is trimmed too.
  function isGiftLine(item, variantId) {
    return item.variant_id === variantId;
  }

  // opts.suppressed: the safety net fired earlier this browser session, so never add the gift again.
  // A gift line Shopify priced above 0 means the free-gift discount did not apply: remove it and suppress.
  function giftAction(cart, rule, opts) {
    const suppressed = !!(opts && opts.suppressed);
    const items = (cart && cart.items) || [];
    const giftLines = items.filter(function (i) { return isGiftLine(i, rule.variantId); });
    const priced = giftLines.filter(function (i) { return Number(i.final_line_price) > 0; });
    if (priced.length) return { type: 'remove', key: priced[0].key, suppress: true };
    const qualifying = items.some(function (i) {
      return !isGiftLine(i, rule.variantId) && i.variant_id !== rule.variantId && i.gift_card !== true;
    });
    const wanted = rule.active && qualifying && !suppressed;
    if (!wanted) {
      return giftLines.length ? { type: 'remove', key: giftLines[0].key } : { type: 'none' };
    }
    if (!giftLines.length) return { type: 'add', variantId: rule.variantId };
    if (giftLines.length > 1) return { type: 'remove', key: giftLines[1].key };
    if (giftLines[0].quantity !== 1) return { type: 'set', key: giftLines[0].key, quantity: 1 };
    return { type: 'none' };
  }

  // The Sample Pack code and the first-order codes are two new-customer offers: one per order.
  // Shopify keeps codes in the order they were added, so the offer that arrived first stays.
  function offerFamily(code) {
    const c = String(code || '').toUpperCase();
    if (c === 'LUXPACK') return 'sample';
    if (c.indexOf('HNC-') === 0) return 'first';
    return null;
  }

  function offerAction(cart) {
    const codes = ((cart && cart.discount_codes) || []).map(function (d) { return d && d.code; }).filter(Boolean);
    const families = codes.map(offerFamily);
    if (families.indexOf('sample') === -1 || families.indexOf('first') === -1) return { type: 'none' };
    const keep = families.filter(Boolean)[0];
    return {
      type: 'codes',
      codes: codes.filter(function (c, i) { return families[i] === null || families[i] === keep; }),
      kept: keep
    };
  }

  return { GIFT_PROP: GIFT_PROP, GIFT_TAG: GIFT_TAG, giftRule: giftRule, giftAction: giftAction, offerAction: offerAction };
});
